import SmartToyIcon from '@mui/icons-material/SmartToy';
import { Fab, Tooltip, Zoom } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useChatDrawer } from '../hooks/use-chat-drawer';

export const AiChatFab = () => {
  const { t } = useTranslation();
  const { isOpen, openDrawer } = useChatDrawer();

  return (
    <Zoom in={!isOpen}>
      <Tooltip title={t('aiChat.drawer.openFab')}>
        <Fab
          color="primary"
          aria-label={t('aiChat.drawer.openFab')}
          aria-expanded={isOpen}
          onClick={openDrawer}
          sx={{
            position: 'fixed',
            bottom: 24,
            right: 24,
            zIndex: (theme) => theme.zIndex.drawer - 1,
          }}
        >
          <SmartToyIcon />
        </Fab>
      </Tooltip>
    </Zoom>
  );
};
